// console.log("IS THIS THE FIRST CODE TO RUN? NO it is not. The constructor of common/config.js is the first code to run")
import '@/app.css';
import '@/transitions.css';
import '@mdi/font/css/materialdesignicons.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css';

import i18n from './plugins/i18n';
import Vue from 'vue';
import remoteLogger from '@/api/remoteLoggerApi';

import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueMasonry from 'vue-masonry-css';
import app from './app.vue';
import utils from '@/common/utils';

const TAG = 'main';
const isDev = process.env.NODE_ENV !== 'production';
Vue.config.performance = isDev;

// Enhance Date to a method for formatting of hh.mm ss
function toHHMMSS() {
  return this.toString().substring(16, 8);
}

Date.prototype.toHHMMSS = toHHMMSS;

Vue.config.productionTip = false;

Vue.use(VueMasonry);
new Vue({
  router,
  store,
  vuetify,
  i18n,

  render: (h) => h(app),
}).$mount('#app');

function onBlurHandler(event) {
  let type = event.srcElement.type;
  console.debug('onBlur', type);
  if (['textarea', 'input'].includes(type)) {
    document.body.exitFullscreen();
    console.debug('scfeen exit');
  }
}
if (navigator.storage && navigator.storage.persist)
  // '.persist()' will silently pass or trigger a dialog
  navigator.storage.persist().then(function (persistent) {
    console.log(`Made storage persistent =${persistent ? 'persistent' : 'denied'}`);
  });
//TODO: check if really necessary: document.addEventListener('click',clickHandler);
document.addEventListener.onBlur = onBlurHandler;

// Listen for dispatchAction and commitMutation Custom Events, sent by registerServiceWorker or service-worker
// Both cannot use vuex store to send actions and mutations
document.addEventListener('dispatchAction', (e) => {
  store.dispatch(e.detail.action, e.detail.params);
});

// Helper event listener allows to emit a vuex mutation without having access to the store
document.addEventListener('commitMutation', (e) => {
  store.commit(e.detail.mutation, e.detail.params);
});

window.addEventListener('offline', (e) => {
  console.log('offline');
  store.commit('setIsConnected', false);
});

window.addEventListener('online', (e) => {
  console.log('online');
  store.commit('setIsConnected', true);
  store.dispatch('sync/forceSynchronizeApp');
  // store.dispatch('lifecycle/initializeSockets'); // not necessary because we have a timer that checks the connection
});
store.commit('setIsConnected', navigator.onLine);

store.commit('theme/provideVuetify', vuetify.framework);

// Initiate the initialization of the app, e.g. loading translations and so on
store.dispatch('lifecycle/init');

// TODO: We could manipulate PWA features here. However it might not be necessary if we stick to set theming and so on while building the app.
// document.querySelector('meta[name="theme-color"]').setAttribute('content', 'red');
remoteLogger.unauthorizedLog(TAG, 'webapp startup');

window.onerror = async (msg, url, line, column, error) => {
  console.error('Uncaught exception', msg, url, line, column, error);
  const errorMessage = `msg=${msg} url=${url} line=${line} column=${column}`;
  remoteLogger.unauthorizedLog(TAG, errorMessage).catch((err) => console.error('windows.onerror', err));
  return false;
};

console.defaultError = console.error.bind(console);
console.error = async function () {
  console.defaultError.apply(console, arguments);
  try {
    let message = '';
    let stack = '';
    let infos = {
      user: localStorage && localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
      lang: localStorage && localStorage.getItem('lang') ? localStorage.getItem('lang') : '',
      sendbox: localStorage && localStorage.getItem('sendbox') ? JSON.parse(localStorage.getItem('sendbox')) : [],
    };
    for (const arg of arguments) {
      if (arg.toString()) {
        if (arg.stack) {
          stack = arg.stack;
        }
        message += message.length > 0 ? ' ' + arg.toString() : arg.toString();
      }
    }
    if (message) {
      await remoteLogger.deviceLog({
        message: message,
        stackTrace: stack,
        additionalInfo: infos,
        messageType: 'error',
      });
    }
  } catch (err) {
    console.error(`could not send deviceLog`, err);
  }
};

console.defaultWarn = console.warn.bind(console);
console.warn = async function () {
  console.defaultWarn.apply(console, arguments);
  /*
  try {
    let message = '';
    for (const arg of arguments) {
      if (typeof arg === 'object') {
        message += message.length > 0 ? ' ' + JSON.stringify(arg) : JSON.stringify(arg);
      } else {
        if (arg.toString()) {
          message += message.length > 0 ? ' ' + arg.toString() : arg.toString();
        }
      }
    }
    if (message) {
      await remoteLogger.deviceLog({
        message: message,
        messageType: 'warning',
      });
    }
  } catch (err) {
    console.error(`could not send deviceLog`, err);
  }
  */
};

let type;

document.addEventListener(
  'visibilitychange',
  function () {
    if (document.hidden) {
      showSendBoxNotification();
    }
  },
  false
);

window.onbeforeunload = function () {
  showSendBoxNotification();
};

function showSendBoxNotification() {
  if (window && 'Notification' in window && Notification.permission == 'granted') {
    const sendbox = localStorage.getItem('sendbox');
    const sendboxItems = JSON.parse(sendbox ? sendbox : '[]');
    if (sendboxItems.length) {
      let notification = new Notification('Ungesendete SendBox Einträge', {
        body: 'Die SendBox Einträge werden versendet sobald Sie die App wieder öffnen und eine Netzwerk-Verbindung besteht.',
      });
      setTimeout(function () {
        notification.close();
      }, 20000);
    }
  } else if (utils.isServiceWorker()) {
    self.registration.showNotification('Ungesendete SendBox Einträge', {
      body: 'Die SendBox Einträge werden versendet sobald Sie die App wieder öffnen und eine Netzwerk-Verbindung besteht.',
    });
  }
}

function updateConnectionStatus() {
  console.log('Connection type changed from ' + type + ' to ' + connection.effectiveType);
  type = connection.effectiveType;
  store.commit('setConnectionType', type);
}

let connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
//not supported on
if (connection) {
  type = connection.effectiveType;

  connection.addEventListener('change', updateConnectionStatus);
  store.commit('setConnectionType', type);
}

// See https://www.vuesnippets.com/posts/long-press/
Vue.directive('longpress', {
  bind: (el, binding, vNode) => {
    if (typeof binding.value !== 'function') {
      // Fetch name of component
      const compName = vNode.context.name;
      // pass warning to console
      let warn = `[longpress:] provided expression '${binding.expression}' is not a function, but has to be`;
      if (compName) {
        warn += `Found in component '${compName}' `;
      }

      console.warn(warn);
    }

    // Define variable
    let pressTimer = null;

    // Define function handlers
    // Create timeout ( run function after 1s )
    let start = (e) => {
      if (e.type === 'click' && e.button !== 0) {
        return;
      }

      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          // Run function
          handler();
        }, 400);
      }
    };

    // Cancel Timeout
    let cancel = (e) => {
      // Check if timer has a value or not
      if (pressTimer !== null) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    };
    // Run Function
    const handler = (e) => {
      binding.value(e);
    };

    // Add Event listeners
    el.addEventListener('mousedown', start);

    // touchstart creates warning.
    // el.addEventListener('touchstart', start);
    // Use passive, see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
    // Test via a getter in the options object to see if the passive property is accessed
    var supportsPassive = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: () => {
          supportsPassive = true;
          return supportsPassive;
        },
      });
      window.addEventListener('testPassive', null, opts);
      window.removeEventListener('testPassive', null, opts);
    } catch (e) {
      console.error('supportsPassive failed', e);
    }

    // Use our detect's results. passive applied if supported, capture will be false either way.
    el.addEventListener('touchstart', start, supportsPassive ? { passive: true } : false);
    // Cancel timeouts if this events happen
    el.addEventListener('click', cancel);
    el.addEventListener('mouseout', cancel);
    el.addEventListener('touchend', cancel);
    el.addEventListener('touchcancel', cancel);
  },
});
